import React from 'react';
import ReactDOM from 'react-dom';
import GetStartedModal from 'views/GetStartedModal';

ReactDOM.render(<GetStartedModal />, document.getElementById('get-started-container'));



// WEBPACK FOOTER //
// ./app/assets/javascripts/apps/get_started.jsx